"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useApprovalWaveStatus } from "@/hooks/waves/useApprovalWaveStatus";
import { MemesSingleWaveDropInfoPanel } from "./MemesSingleWaveDropInfoPanel";
import { SingleWaveDropWrapper } from "./SingleWaveDropWrapper";
import { useSingleWaveDropData } from "./useSingleWaveDropData";
interface MemesSingleWaveDropProps {
  readonly drop: ExtendedDrop;
  readonly onClose: () => void;
}
export const MemesSingleWaveDrop: React.FC<MemesSingleWaveDropProps> = t0 => {
  const $ = _c(16);
  const {
    drop: initialDrop,
    onClose
  } = t0;
  const {
    drop,
    wave,
    extendedDrop
  } = useSingleWaveDropData(initialDrop, onClose);
  let t1;
  if ($[0] !== wave) {
    t1 = {
      wave
    };
    $[0] = wave;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    winningThreshold,
    isVotingClosed,
    isVotingControlsLocked
  } = useApprovalWaveStatus(t1);
  if (!extendedDrop || !wave || !drop) {
    return null;
  }
  let t2;
  if ($[2] !== extendedDrop || $[3] !== isVotingClosed || $[4] !== isVotingControlsLocked || $[5] !== onClose || $[6] !== wave) {
    t2 = <MemesSingleWaveDropInfoPanel drop={extendedDrop} wave={wave} onClose={onClose} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked} />;
    $[2] = extendedDrop;
    $[3] = isVotingClosed;
    $[4] = isVotingControlsLocked;
    $[5] = onClose;
    $[6] = wave;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== drop || $[9] !== isVotingClosed || $[10] !== isVotingControlsLocked || $[11] !== onClose || $[12] !== t2 || $[13] !== wave || $[14] !== winningThreshold) {
    t3 = <SingleWaveDropWrapper drop={drop} wave={wave} onClose={onClose} winningThreshold={winningThreshold} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked}>{t2}</SingleWaveDropWrapper>;
    $[8] = drop;
    $[9] = isVotingClosed;
    $[10] = isVotingControlsLocked;
    $[11] = onClose;
    $[12] = t2;
    $[13] = wave;
    $[14] = winningThreshold;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};